import { Link } from "react-router-dom";
import { useCompare } from "../context/CompareContext";

export default function CompareBar() {
  const { compareList, removeCompare } = useCompare();

  if (compareList.length === 0) return null;

  return (
    <div className="print:hidden fixed left-0 right-0 z-50 bg-navy-900/95 backdrop-blur-md border-t border-white/10 px-4 py-3" style={{ bottom: "var(--company-bar-height, 0px)" }}>
      <div className="max-w-3xl mx-auto flex items-center gap-3 flex-wrap">
        <span className="text-white/40 text-xs shrink-0">Comparing Providers:</span>
        {compareList.map((p) => (
          <div key={p.npi} className="flex items-center gap-1.5 bg-navy-800 border border-white/10 rounded-lg px-3 py-1.5">
            <span className="text-white/70 text-xs">{p.firstName} {p.lastName}</span>
            <button onClick={() => removeCompare(p.npi)} className="text-white/30 hover:text-white/70 text-xs ml-1">×</button>
          </div>
        ))}
        {compareList.length < 3 && (
          <span className="text-white/20 text-xs">+ add {3 - compareList.length} more</span>
        )}
        <div className="ml-auto">
          <Link
            to={`/compare?npis=${compareList.map((p) => p.npi).join(",")}&names=${compareList.map((p) => encodeURIComponent(p.firstName + " " + p.lastName)).join(",")}&states=${compareList.map((p) => p.state || "").join(",")}&totals=${compareList.map((p) => Math.round(p.totalPayments)).join(",")}`}
            className="btn-primary text-sm px-4 py-2"
          >
            Compare {compareList.length} provider{compareList.length !== 1 ? "s" : ""} →
          </Link>
        </div>
      </div>
    </div>
  );
}